/**
 * @description 投保對象年齡用
*/
export enum AgeOptAge {
  /** 大於 15 歲 */
  OverFifteen = '0',
  /** 小於 15 歲 */
  UnderFifteen = '1'
}
